'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logoSvg = require('./logo.svg.react');

var _logoSvg2 = _interopRequireDefault(_logoSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSizeProps = function getSizeProps(size) {
  switch (size) {
    case 'large':
      return {
        width: 240,
        height: 56
      };
    case 'medium':
      return {
        width: 130.5,
        height: 32
      };
    default:
      return {
        width: 128,
        height: 128
      };
  }
};

var ClientLogo = function ClientLogo(_ref) {
  var logoUrl = _ref.logoUrl,
      size = _ref.size;

  if (logoUrl) {
    return _react2.default.createElement('img', { alt: '', src: logoUrl });
  }

  var sizeProps = getSizeProps(size);

  return _react2.default.createElement(_logoSvg2.default, sizeProps);
};

ClientLogo.propTypes = process.env.NODE_ENV !== "production" ? {
  size: _propTypes2.default.string,
  logoUrl: _propTypes2.default.string
} : {};

exports.default = ClientLogo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/client-logo/ClientLogo.js
// module id = 1355
// module chunks = 249